import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

///
export const TitleBlocked = () => {
    const { pub: { title, blocked } } = useCardContext();

    return blocked?.blockedOn
        ? (
            <MprcFeedTypography variant="title" component="div" noWrap={true} color="warning">
                <span title={title}>{title}</span>
            </MprcFeedTypography>
        )
        : null;
};
